export { default as DiseaseEncyclopediaView } from './segments/ui/DiseaseEncyclopediaView';
export { default as useDiseaseEncyclopediaViewModel } from './segments/hooks/useDiseaseEncyclopediaViewModel';
